import { Space, Button } from 'antd';
import { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import DrawerWithAutoWidth from '../../../../components/DrawerWithAutoWidth';
import AddAutoplaySettingsForm from './AddAutoplaySettingsForm';

export type AutoplaySettingsDrawerProps = {
    onClose: () => void;
    visible: boolean;
    moduleId: string;
};

const AutoplaySettingsDrawer = ({ onClose, visible, moduleId }: AutoplaySettingsDrawerProps) => {
    const { t } = useTranslation(['autoplayModuleDetails']);

    return (
        <DrawerWithAutoWidth
            extra={
                <Space>
                    <Button onClick={onClose}>{t('autoplayModuleDetails:autoplaySettingsDrawer.cancelButton')}</Button>
                    <Button form="addAutoplaySettingsForm" htmlType="submit" type="primary">
                        {t('autoplayModuleDetails:autoplaySettingsDrawer.submitButton')}
                    </Button>
                </Space>
            }
            onClose={onClose}
            title={t('autoplayModuleDetails:autoplaySettingsDrawer.title.create')}
            visible={visible}
            destroyOnClose
        >
            <AddAutoplaySettingsForm moduleId={moduleId} onComplete={onClose} />
        </DrawerWithAutoWidth>
    );
};

export default AutoplaySettingsDrawer;

export const useAutoplaySettingsDrawer = (moduleId: string) => {
    const [visible, setVisible] = useState(false);

    const actions = useMemo(
        () => ({
            open: () => setVisible(true),
            close: () => setVisible(false),
        }),
        [setVisible]
    );

    return {
        ...actions,
        render: () => <AutoplaySettingsDrawer moduleId={moduleId} onClose={actions.close} visible={visible} />,
    };
};
